export default {
  ALREADY_DONE: 'يبدوا أن هذا الإجراء تم القيام به مسبقا, الرجاء تحديث الصفحة',
  PROCESSED_REQUEST: 'هذا الطلب تمت معالجته مسبقا, الإجراء المتخذ في هذه الجلسة غير محتسب',
  ACCESSING_A_PROCESSED_REQUEST: 'هذا الطلب الذي تحاول عرضه تم معالجته مسبقا, الرجاء تحديث الصفحة',
  ASSIGNING_A_COMPLETED_REQUEST: 'هذا الطلب تم معالجته مسبقا, الرجاء تحديث الصفحة',
  ASSIGNING_AN_ASSIGNED_REQUEST: 'هذا الطلب تحت معالجة شخص آخر, الرجاء تحديث الصفحة',
  GENERAL: 'حدث  خطأ ما',
};
